import { jsonp } from '@ifeng-fe/ui_base';
import { formatImage } from '@ifeng-fe/public_method';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
const topicUrl = topicApiUrl;
/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/c';
}

const md5 = require('@ifeng-fe/md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

let host = '';

if (typeof window !== 'undefined') {
    host = window.location.host;
}

// 新专题页话题接口
export const getTopicData = async (id) => {
    return await jsonp(`${apiBaseUrl}/api/content/topic/getTopics/${id}/getTopicData`, {
        jsonpCallback: 'getTopicData',
        cache: false,
    });
};

// 获取文章评论数
export const getCommentCount = async (docUrl) => {
    // const { schemaCheck } = await import('@ifeng-fe/container_content/common/client/services/validate');
    let data = [];
    const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';

    try {
        data = await jsonp(`//${ commentDomain }/get/multicount`, {
            data: {
                doc_url: docUrl.join('|'),
                format: 'js',
            },
            jsonpCallback: `${createJsonpCallbackName('getCommentCount')}`,
            cache: false,
        });

        // const requestUrl = `${host}/${ commentDomain }/get/multicount`;

        // data = schemaCheck(data, 'commentCountSchema', requestUrl);
    } catch (e) {
        console.error(e);
    }

    return data;
};

/**
 * 获取专题预览数据
 * @param {String} id 专题ID
 * @param {String} cookieInfo 权限cookie
 * @param {String} biz 标识是否是地方站
 * @param {String} token 权限token
 * @returns {Object} 返回数组
 */
export const getTopicPreviewData = async (id, cookieInfo, biz, token) => {
    try {
        const callback = createJsonpCallbackName('getTopicPreviewData');

        const data = await jsonp(
            `${topicUrl}/client/content/topic/getTopicPreviewData/${id}/${cookieInfo}/${biz}/${token}/${callback}`,
            {
                jsonpCallback: callback,
                cache: false,
            },
        );

        let topic = {};

        if (data.data) {
            const val = data.data;

            val.modules.sort((a, b) => {
                return a.sequence > b.sequence ? 1 : -1;
            });

            let moduleIndex = 1;

            val.modules.forEach((item) => {
                if (item.display === 1) {
                    if (item.type !== 'slide' && item.type !== 'flow') {
                        item['moduleIndex'] = moduleIndex++;
                    } else if (item.type === 'slide') {
                        item.data.articleList = item.data.articleList.map((slide) => ({
                            ...item.sourceDocMap[slide.id],
                            ...slide,
                        }));

                        item.data = [...item.data.articleList];

                        item.data.forEach((n) => {
                            n.thumbnails =
                                (n.thumbnails &&
                                    n.thumbnails.image &&
                                    n.thumbnails.image.length > 0 &&
                                    n.thumbnails.image) ||
                                [];

                            n.thumbnails = n.thumbnails.map((k) => ({
                                ...k,
                                url: formatImage(k.url, 650, 330),
                            }));
                        });
                    } else if (item.type === 'flow' && item.data.articleList) {
                        item.data.articleList = item.data.articleList.map((flow) => ({
                            ...item.sourceDocMap[flow.id],
                            ...flow,
                        }));

                        item.data.articleList = item.data.articleList.map((flow) => ({
                            ...flow,
                            thumbnails: (flow.thumbnails && flow.thumbnails.image) || [],
                        }));

                        item.data.articleList = item.data.articleList.slice(0, item.data.showNum);
                    }
                }
            });

            topic = {
                ...data.data,
                modules: val.modules,
            };
        }

        return topic;
    } catch (e) {
        console.error(e);
    }

    return {};
};
export const getQuanDataForP = async (modules) => {
    let ids = [];

    modules.forEach((item, index) => {
        if (item.articleList?.length > 0) {
            return item.articleList.forEach((it) => {
                if (it.type === 'quan') {
                    ids.push(it['id']);
                }
            });
        }
    });
    if (ids.length === 0) {
        return modules;
    }
    ids = ids.join(',');
    console.log(ids, 'ids');
    try {
        const callback = createJsonpCallbackName('getQuanDataForP');

        const { data } = await jsonp(`${apiBaseUrl}/content/topic/getQuanDataListForP/${ids}/${callback}`, {
            jsonpCallback: callback,
            cache: false,
        });
        const { likeCountMap, commentMap, quanDataMap } = data;

        for (const item of modules) {
            if (item.data && item.data.length > 0) {
                for (const its of item.data) {
                    if (its.articleList && its.articleList.length > 0) {
                        for (let it of its.articleList) {
                            if (likeCountMap[it['id']]) {
                                it['likeInfo'] = likeCountMap[it['id']];
                            } else {
                                it['likeInfo'] = { likeCount: 0 };
                            }
                            if (commentMap[it['id']]) {
                                it['commentInfo'] = commentMap[it['id']];
                            } else {
                                it['commentInfo'] = { num: 0 };
                            }
                            if (quanDataMap[it['id']]) {
                                it = Object.assign(it, quanDataMap[it['id']]);
                            }
                        }
                    }
                }
            }
        }

        return modules;
    } catch (e) {
        console.error(e);

        return modules;
    }
};

// 获取URL参数
export const getQueryString = (paramKey, defaultV) => {
    if (typeof window === 'undefined') return '';

    let sURLVariables = '';
    let i = 0;
    let sParameterName = '';
    const sPageURL = window.location.search.substring(1);

    if (sPageURL.match(/&/)) {
        sURLVariables = sPageURL.split('&');
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === paramKey) return sParameterName[1];
        }
    } else {
        sURLVariables = sPageURL.split('=');

        return sURLVariables[0] === paramKey ? sURLVariables[1] : defaultV || '';
    }

    return defaultV;
};
